import { render, staticRenderFns } from "./product-supliers-details.vue?vue&type=template&id=c6118f92&scoped=true&"
import script from "./product-supliers-details.vue?vue&type=script&lang=js&"
export * from "./product-supliers-details.vue?vue&type=script&lang=js&"
import style0 from "./product-supliers-details.vue?vue&type=style&index=0&id=c6118f92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6118f92",
  null
  
)

export default component.exports